import { ModelInstance, BaseModel, ToFrontHook, ToBackHook, listField } from './util';
import { Team } from './team';
import { LeaguePlayer } from './league-player';

@ModelInstance({
  mappingFields: {
    teams: 'teams',
    league_players: 'leaguePlayers',
  },
  relation: {
    teams: listField(Team),
    leaguePlayers: listField(LeaguePlayer),
  }
})
export class TeamsAndUsers extends BaseModel {
  teams: Team[];
  leaguePlayers: LeaguePlayer[];

  get isEmpty(): boolean {
    return (!this.teams || this.teams.length === 0) &&
      (!this.leaguePlayers || this.leaguePlayers.length === 0);
  }

  @ToFrontHook
  static toFront(data: any): any {}

  @ToBackHook
  static toBack(data: any): any {}
}
